import {
    IDeliveryOrderPayload,
    IDelivery,
    IDeliveryPayload,
    IInitialDeliveryFormValues
} from "../../../Types/MeetingPlanning/deliveryForm"
import { ProductBasket } from "../../Basket/basketTypes"

export enum MeetingPlanningActionTypes {
    CHANGE_INITIAL_DELIVERY_FORM = "meetingPlanning/CHANGE_INITIAL_DELIVERY_FORM",
    CHANGE_DELIVERY_DATA = "meetingPlanning/CHANGE_DELIVERY_DATA",
    CHANGE_DELIVERIES_LIST = "meetingPlanning/CHANGE_DELIVERIES_LIST",
    ADD_DELIVERY_ORDER = "meetingPlanning/ADD_DELIVERY_ORDER",
    RESET_MEETING_DATA = "meetingPlanning/RESET_MEETING_DATA",
    DELETE_DELIVERY = "meetingPlanning/DELETE_DELIVERY",
}

export type ChangeInitialDeliveryForm = Readonly<{
    type: MeetingPlanningActionTypes.CHANGE_INITIAL_DELIVERY_FORM
    payload: IInitialDeliveryFormValues
}>

export type ChangeDeliveryData = Readonly<{
    type: MeetingPlanningActionTypes.CHANGE_DELIVERY_DATA
    payload: IDeliveryPayload
}>

export type ChangeDeliveriesList = Readonly<{
    type: MeetingPlanningActionTypes.CHANGE_DELIVERIES_LIST
    payload: IDelivery[]
}>

export type AddDeliveryOrder = Readonly<{
    type: MeetingPlanningActionTypes.ADD_DELIVERY_ORDER
    payload: IDeliveryOrderPayload
}>

export type ResetMeetingData = Readonly<{
    type: MeetingPlanningActionTypes.RESET_MEETING_DATA
}>

export type DeleteDelivery = Readonly<{
    type: MeetingPlanningActionTypes.DELETE_DELIVERY
    payload: string
}>

export const ChangeInitialDeliveryForm = (payload: IInitialDeliveryFormValues): ChangeInitialDeliveryForm => ({
    type: MeetingPlanningActionTypes.CHANGE_INITIAL_DELIVERY_FORM,
    payload,
})

export const ChangeDeliveryData = (payload: IDeliveryPayload): ChangeDeliveryData => ({
    type: MeetingPlanningActionTypes.CHANGE_DELIVERY_DATA,
    payload,
})

export const ChangeDeliveriesList = (payload: IDelivery[]): ChangeDeliveriesList => ({
    type: MeetingPlanningActionTypes.CHANGE_DELIVERIES_LIST,
    payload,
})

export const AddDeliveryOrder = (payload: IDeliveryOrderPayload): AddDeliveryOrder => ({
    type: MeetingPlanningActionTypes.ADD_DELIVERY_ORDER,
    payload,
})

export const DeleteDelivery = (payload: string): DeleteDelivery => ({
    type: MeetingPlanningActionTypes.DELETE_DELIVERY,
    payload,
})

export const resetMeetingData = (): ResetMeetingData => ({
    type: MeetingPlanningActionTypes.RESET_MEETING_DATA
})

export type MeetingPlanningAction =
    | ChangeInitialDeliveryForm
    | ChangeDeliveryData
    | ChangeDeliveriesList
    | AddDeliveryOrder
    | ResetMeetingData
    | DeleteDelivery
